import { Link, Outlet } from 'react-router-dom';
import { Reveal } from '../shared/ui';
import { useScrollToTop } from '../shared/hooks/useScrollToTop';

export function AuthLayout() {
  useScrollToTop();
  return (
    <div className="flex min-h-screen flex-col bg-black text-[#f5f5f7]">
      <a
        href="#auth-main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:rounded-lg focus:bg-accent focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-black"
      >
        Skip to main content
      </a>

      <header className="h-16 border-b-2 border-[#1d1d1f]">
        <Reveal kind="stagger" immediate className="mx-auto flex h-full max-w-[1024px] items-center justify-between px-[22px]">
          <Link to="/" aria-label="RT Equipment & Haulage home">
            <img src="/logo-white.png" alt="RT Equipment & Haulage" className="h-9 w-auto" />
          </Link>
          <Link to="/" className="text-xs text-[#a1a1a6] transition-colors hover:text-white">
            Back to site
          </Link>
        </Reveal>
      </header>

      <div id="auth-main-content" className="flex flex-1 justify-center px-[22px] pb-[clamp(56px,10vw,96px)] pt-[clamp(40px,8vw,72px)]">
        <div className="w-full max-w-[440px]">
          <Outlet />
        </div>
      </div>

      <footer className="border-t-2 border-[#1d1d1f] px-[22px] py-5 text-center text-xs text-[#86868b]">
        © {new Date().getFullYear()} RT Equipment & Haulage
      </footer>
    </div>
  );
}
